package pl.mothdigital.neuronowi.pages.contact

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.common.resources.StringResources
import pl.mothdigital.neuronowi.components.layouts.*
import pl.mothdigital.neuronowi.components.sections.contactdetails.*
import pl.mothdigital.neuronowi.components.sections.contactheader.*
import pl.mothdigital.neuronowi.components.sections.contactmap.*
import pl.mothdigital.neuronowi.components.widgets.*

@Page
@Composable
fun ContactPage() {
    PageLayout(
        title = StringResources.CONTACT_PAGE_TITLE,
        description = StringResources.META_DESC_CONTACT,
        contentAlignment = Alignment.TopStart,
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            VerticalSpacer(78.px)
            ContactHeaderSection()
            ContactDetailsSection()
            MapSection()
        }
    }
}
